<template>
    <div id="nav-menu">
        <div class="firm-name">
            <img src="../../assets/img/logo1.png" alt="">
        </div>
        <div class="menu">
            <ul>
                <li v-for="(item, index) in menu" @click="isSelect!=item.component&&setNav(item, index)"
                    :class="{ active: isSelect == item.component, nocheck: !item.isclick }" :key="index">
                    <div class="logo"><img :src="isSelect == item.component ? item.activeimg : item.img" /></div>
                    <div class="name">{{ item.name }}</div>
                </li>
            </ul>
        </div>
        <div class="user">
            <ul>
                <!-- <li v-if="dshow">
                    <div class="logo">
                        <video id="v2" autoplay loop muted height="60rem" width="60rem">
                            <source src="../../assets/mp4/3d.mp4" type="video/mp4" />
                        </video>
                        <img src="@/assets/img/san.png" style="width:60rem;height:60rem" />
                    </div>
                    <div class="name">3D</div>
                </li> -->
                <li style="border-top:1px solid #CCCCCC;" @click="goCenter" :class="{ active: Name == 'PersonalCenter' }">
                    <div class="logo"><img :src="userInfo.img" /></div>
                    <div class="name u-line-2">{{ userInfo.realName }}</div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { debug } from 'console'

export default {
    data() {
        return {
            isSelect: "Overview",
            dshow: false
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.homeitem.user
        },
        projectId() {
            return this.$store.getters.projectId
        },
        projectInfo() {
            return this.$store.getters.selProjectInfo
        },
        Name() {
            return this.$route.name;
        },
        routeName() {
            return this.$route.params.name;
        },
        menu() {
            let menu = [
                {
                    path: "/Home/Overview/SubstationManagement",
                    component: "Overview",
                    img: require("../../assets/img/zl.png"),
                    activeimg: require("../../assets/img/zl-a.png"),
                    name: "总览",
                    isclick: true
                },
                {
                    path: "/Home/PowerDistribution/index",
                    component: "PowerDistribution",
                    img: require("../../assets/img/pd.png"),
                    activeimg: require("../../assets/img/pd-a.png"),
                    name: "配电",
                    isclick: false
                }
                , {
                    path: "/Home/Photovoltaic/index",
                    component: "Photovoltaic",
                    img: require("../../assets/img/gf.png"),
                    activeimg: require("../../assets/img/gf-a.png"),
                    name: "光伏",
                    isclick: false
                },
                {
                    path: "/Home/PowerStation/index",
                    component: "PowerStation",
                    img: require("../../assets/img/cn.png"),
                    activeimg: require("../../assets/img/cn-a.png"),
                    name: "储能",
                    isclick: false
                },
                {
                    path:"/Home/Chargingpile/index",
                    component: "Chargingpile",
                    img:require("../../assets/img/cdz.png"),
                    activeimg:require("../../assets/img/cdz-a.png"),
                    name:"充电桩",
                    isclick: false
                },
                {
                    path: "/Home/EnergyConsumption/index",
                    component: "EnergyConsumption",
                    img: require("../../assets/img/nh.png"),
                    activeimg: require("../../assets/img/nh-a.png"),
                    name: "能耗",
                    isclick: false
                },
                {
                    path: "/Home/PaymentMeter/index",
                    component: "PaymentMeter",
                    img: require("../../assets/img/jf.png"),
                    activeimg: require("../../assets/img/jf-a.png"),
                    name: "计费",
                    isclick: false
                },
                {
                    path: "/Home/WorkBench/Homepage",
                    component: "WorkBench",
                    img: require("../../assets/img/work.png"),
                    activeimg: require("../../assets/img/work-a.png"),
                    name: "工作台",
                    isclick: true
                },
                // {
                //     path:"",
                //     img:require("../../assets/img/more.png"),
                //     activeimg:require("../../assets/img/more-a.png"),
                //     name:"更多"
                // },  
            ]

            if (this.projectInfo.menuAuth) {
                let list = ['PowerDistribution', 'Photovoltaic', 'EnergyConsumption', 'PaymentMeter']
                menu.forEach(item => {
                    if (list.includes(item.component)) {
                        this.projectInfo.menuAuth.split(',').forEach(elm => {
                            if (item.component == elm) {
                                item.isclick = true
                            }
                        })
                    }

                })

                // if(this.projectId!=1){
                //     menu = menu.filter(e=>e.name!='充电桩')
                // }

                if(this.projectId==1){
                    menu = menu.map(e=>{
                        if(e.name=='储能'||e.name=='充电桩'){
                            e.isclick = true
                        }
                        return e
                    })
                }
                if (this.projectInfo.menuAuth.indexOf('3D') != -1) {  //是否有3d
                    this.dshow = true
                } else {
                    this.dshow = false
                }
            }
            // if(this.projectId==15){ //鲁泰大楼
            //     menu.map(e=>{
            //         if(e.name=='配电'||e.name=='光伏'||e.name=='计费'){
            //             e.isclick = false
            //         }
            //         return e
            //     })
            // }else if(this.projectId==1){
            //     menu.map(e=>{
            //         if(e.name=='能耗'){
            //             e.isclick = true
            //         }
            //         return e
            //     })
            // }else{
            //     menu.map(e=>{
            //         if(e.name=='能耗'||e.name=='光伏'||e.name=='计费'){
            //             e.isclick = false
            //         }
            //         return e
            //     })
            // }
            return menu
        }
    },
    watch: {
        routeName(n, o) {
            this.isSelect = n
            sessionStorage.setItem('isSelect', this.isSelect)
        },
        $route: {
            handler: function (to, form) {
                this.isSelect = to.params.name
                sessionStorage.setItem('isSelect', this.isSelect)
            },
            deep: true,
        }
    },
    mounted() {
        this.isSelect = "Overview"
        if (sessionStorage.getItem('isSelect')) {
            this.isSelect = sessionStorage.getItem('isSelect')
        }

    },
    methods: {
        goCenter() {
            this.isSelect = ""
            this.$router.push("/PersonalCenter/index");
        },
        setNav(item, index) {
            if (item.isclick) {
                this.$router.push(item.path);
                this.isSelect = item.component;
                sessionStorage.setItem('isSelect', this.isSelect)
            }

        }
    }
}
</script>

<style scoped lang="less">
#nav-menu {
    text-align: center;
    position: relative;
    height: 100%;

    .firm-name {
        .h(64);
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
        align-items: center;

        // img {
        //     width: 90%;
        // }
    }

    .user {
        position: absolute;
        bottom: 0px;
        width: 100%;
        left: 0;
        font-size: 14rem;

        li {
            padding: 10px 5px;
            cursor: pointer;
            position: relative;
        }

        img {
            width: 34rem;
            height: 34rem;
            border-radius: 50%;
        }

        .active {
            background: rgba(13, 148, 255, 0.08);
            color: #0D94FF;
        }

        .active::before {
            content: "";
            width: 4px;
            background: #0D94FF;
            position: absolute;
            left: 0;
            height: 100%;
            top: 0;
        }
    }

    .menu {
        li {
            padding: 11rem 0;
            color: #666666;
            min-height: 66rem;
            position: relative;
            cursor: pointer;

            .logo {
                height: 24rem;
                line-height: 24rem;
                img {
                    // width: 20rem;
                    // height: 18rem;
                }
            }

            .name {
                font-size: 16rem;
            }

            &:hover{
                background: rgba(13, 148, 255, 0.08);
                color: #0D94FF;
                ::before {
                    content: "";
                    width: 4px;
                    background: #0D94FF;
                    position: absolute;
                    left: 0;
                    height: 100%;
                    top: 0;
                }
            }
        }

        .nocheck {
            background: #F6F6F6;
            cursor: no-drop;
            opacity: 0.5;
        }

        .active {
            background: rgba(13, 148, 255, 0.08);
            color: #0D94FF;
        }

        .active::before {
            content: "";
            width: 4px;
            background: #0D94FF;
            position: absolute;
            left: 0;
            height: 100%;
            top: 0;
        }
    }
}
</style>